import { computed, inject, provide } from 'vue';

import type { ComputedRef, InjectionKey } from 'vue';

export interface IContextSlots {
  emptyText?: (...args: any[]) => any;
  expandIcon?: (...args: any[]) => any;
  header?: (...args: any[]) => any;
  footer?: (...args: any[]) => any;
  summary?: (...args: any[]) => any;
  bodyCell?: (...args: any[]) => any;
  headerCell?: (...args: any[]) => any;
  customFilterIcon?: (...args: any[]) => any;
  customFilterDropdown?: (...args: any[]) => any;
  [key: string]: ((...args: any[]) => any) | undefined;
}

type TSlotsContextProps = ComputedRef<IContextSlots>;
const SlotsContextKey: InjectionKey<TSlotsContextProps> = Symbol('cds:table:slots');
export const useProvideSlots = (props: TSlotsContextProps) => {
  provide(SlotsContextKey, props);
};

export const useInjectSlots = () => inject(SlotsContextKey, computed(() => ({})) as TSlotsContextProps);
